import { render, staticRenderFns } from "./ReferenceListPage.vue?vue&type=template&id=02c780d2&scoped=true"
import script from "./ReferenceListPage.vue?vue&type=script&lang=js"
export * from "./ReferenceListPage.vue?vue&type=script&lang=js"
import style0 from "./ReferenceListPage.vue?vue&type=style&index=0&id=02c780d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c780d2",
  null
  
)

export default component.exports